import React from 'react'
import {
    FaArrowLeft,
    FaCheckDouble,
    FaPaperPlane,
    FaQrcode,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import NavigateButton from '../../components/buttonsNavigate';
import { IoSettingsSharp } from 'react-icons/io5';
import { MdOutlineManageHistory } from 'react-icons/md';
function V2Return() {
    const navigate = useNavigate();
    const permissions = JSON.parse(localStorage.getItem("permissions"));
    return (
        <>
            {/* Header */}
            <div className='h-full bg-white'>
                <div className="  sticky top-0 flex flex-col bg-white">
                    <div className=" w-full bg-dbase h-16">
                        <div className=" container flex relative flex-row gap-4 justify-between w-full text-white  h-full my-auto">
                            <button onClick={() => navigate(-1)}>
                                <FaArrowLeft />
                            </button>
                            <div className="flex flex-col container">
                                <div className="flex gap-2 items-center">
                                    <h2 className="text-xl my-auto">Return</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" w-screen  bg-white my-4 container"></div>
                <div className=" grid container gap-x-6 gap-y-4">
                    <>
                        {(window.location.host.startsWith("localhost") || window.location.host === "pda.ishtari.com") && (
                            <>
                                {window.location.host !== "pda.ishtari.com.gh" &&
                                    window.location.host !== "pda.ishtari.com" && (
                                        <NavigateButton
                                            icon={<FaQrcode />}
                                            name={"ARRIVED"}
                                            arname={" وصل"}
                                            color={"bg-[rgb(5,150,105)]"}
                                            onclick={() => navigate("arrived")}
                                        />
                                    )}
                                {permissions.pda_send_to_control && (
                                    <NavigateButton
                                        icon={<FaPaperPlane />}
                                        name={"Send To Control"}
                                        arname={"إرسال للتحكم "}
                                        color={"bg-[rgb(37,99,235)]"}
                                        onclick={() => navigate("sendtocontrol")}
                                    />)}
                                {window.location.host !== "pda.ishtari.com.gh" &&
                                    permissions.pda_recieved_in_control &&

                                    (
                                        <NavigateButton
                                            icon={<FaCheckDouble />}
                                            name={"Received in Control"}
                                            arname={"تم استلامه في التحكم "}
                                            color={"bg-[rgb(8,145,178)]"}
                                            onclick={() => navigate("receivedincontrol")}
                                        />
                                    )}
                                {permissions.pda_recieved_in_control && (
                                    <NavigateButton
                                        icon={<IoSettingsSharp />}
                                        name={"Control"}
                                        arname={" التحكم"}
                                        color={"bg-[rgb(96,165,250)]"}
                                        onclick={() => navigate("control")}
                                    />
                                )}
                                {permissions.pda_return_reason_for_product && (
                                    <NavigateButton
                                        icon={<MdOutlineManageHistory />}
                                        name={"RETURN REASON FOR PRODUCT"}
                                        arname={"سبب استرداد المنتج"}
                                        color={"bg-[rgb(0,145,6)]"}
                                        onclick={() => navigate("rrfp")}
                                    />
                                )}
                            </>
                        )}
                        {(window.location.host === "pda.ishtari.com.gh" || window.location.host === "pda.energyplus-lb.com") && (
                            <>
                                {window.location.host !== "pda.ishtari.com.gh" &&
                                    window.location.host !== "pda.ishtari.com" && (
                                        <NavigateButton
                                            icon={<FaQrcode />}
                                            name={"ARRIVED"}
                                            arname={" وصل"}
                                            color={"bg-[rgb(5,150,105)]"}
                                            onclick={() => navigate("arrived")}
                                        />
                                    )}
                                <NavigateButton
                                    icon={<FaPaperPlane />}
                                    name={"Send To Control"}
                                    arname={"إرسال للتحكم "}
                                    color={"bg-[rgb(37,99,235)]"}
                                    onclick={() => navigate("sendtocontrol")}
                                />
                                {window.location.host !== "pda.ishtari.com.gh" &&
                                    (
                                        <NavigateButton
                                            icon={<FaCheckDouble />}
                                            name={"Received in Control"}
                                            arname={"تم استلامه في التحكم "}
                                            color={"bg-[rgb(8,145,178)]"}
                                            onclick={() => navigate("receivedincontrol")}
                                        />
                                    )}
                                <NavigateButton
                                    icon={<IoSettingsSharp />}
                                    name={"Control"}
                                    arname={" التحكم"}
                                    color={"bg-[rgb(96,165,250)]"}
                                    onclick={() => navigate("control")}
                                />
                                <NavigateButton
                                    icon={<MdOutlineManageHistory />}
                                    name={"RETURN REASON FOR PRODUCT"}
                                    arname={"سبب استرداد المنتج"}
                                    color={"bg-[rgb(0,145,6)]"}
                                    onclick={() => navigate("rrfp")}
                                />
                            </>
                        )}
                    </>
                </div>
            </div>

        </>
    )
}

export default V2Return
